'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _visitor_info = require('../visitor_info');

var _visitor_info2 = _interopRequireDefault(_visitor_info);

var _deck_header = require('./deck_header');

var _chat = require('../chat');

var _chat2 = _interopRequireDefault(_chat);

var _services = require('../../services');

var _contacts = require('../contacts');

var _contacts2 = _interopRequireDefault(_contacts);

require('../css/custom.css');

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import {JM_API} from '../../helpers/Constants'

// import { Notify } from '../Notifications/Notifications'


var Deck = function (_Component) {
    _inherits(Deck, _Component);

    function Deck(props) {
        _classCallCheck(this, Deck);

        var _this = _possibleConstructorReturn(this, (Deck.__proto__ || Object.getPrototypeOf(Deck)).call(this, props));

        _this.changeUnreadMessageCount = function (unreadMessageCount) {

            if (_this.state.unreadMessageCount !== unreadMessageCount) {
                _this.setState({
                    unreadMessageCount: unreadMessageCount
                });
            }
        };

        _this.moveToVisibleDecks = function () {
            _this.props.switchDecks(_this.props.deck);
        };

        _this.onMinimise = function () {
            _this.setState({
                deckMode: 'minimised',
                deckBodyDisplayStyle: 'none'
            });
        };

        _this.onMaximise = function () {
            _this.setState({
                deckMode: 'maximised',
                deckBodyDisplayStyle: 'block'
            });
        };

        _this.leaveMeeting = function () {

            _services.api.leaveMeetingRequest(_this.props.deck.meeting_id).then(function (res) {
                console.log("Leave meeting success. Res : ", res);
                if (res.status === Constants.SUCCESS) {
                    console.log("Leave Meeting Successful");

                    // let notificationDetails = {
                    //     title : "Leave Meeting",
                    //     message : "Successfully left meeting",
                    //     level : "success",
                    //     instance : this,
                    //     autoDismiss : 5,
                    //     actionLabel : "OK"
                    // }

                    // Notify().showNotification(notificationDetails)

                    _this.props.removeDeck(_this.props.deck.meeting_id);
                    if (_services.chatEvents.onMeetingLeft) {
                        _services.chatEvents.onMeetingLeft(res);
                    }
                } else {
                    console.log("Leave Meeting Failed");

                    // let notificationDetails = {
                    //     title : "Leave Meeting",
                    //     message : "Failed to leave meeting",
                    //     level : "error",
                    //     instance : this,
                    //     autoDismiss : 5,
                    //     actionLabel : "OK"
                    // }

                    // Notify().showNotification(notificationDetails)
                    if (_services.chatEvents.onMeetingLeft) {
                        _services.chatEvents.onMeetingLeft(res);
                    }
                }
            }).catch(function (err) {
                console.log("leaveMeetingRequest::catch:", err);
            });
        };

        _this.endMeeting = function () {
            _services.api.endMeetingRequest(_this.props.deck.meeting_id).then(function (res) {
                console.log("Leave meeting success. Res : ", res);
                if (res.status === Constants.SUCCESS) {
                    console.log("End Meeting Successful");
                    _this.props.removeDeck(_this.props.deck.meeting_id);
                    if (_services.chatEvents.onMeetingEnded) {
                        _services.chatEvents.onMeetingEnded(_this.props.deck.meeting_id);
                    }
                } else {
                    console.log("End Meeting Failed");
                }
            }).catch(function (err) {
                console.log("endMeetingRequest::catch:", err);
            });
        };

        _this.onClose = function (meetingId) {
            if (_services.chatEvents.onMeetingClosed) {
                _services.chatEvents.onMeetingClosed(meetingId);
            }
            _this.props.removeDeck(meetingId);
        };

        _this.onDeckMenuItemChange = function (newDeckMenuItem) {
            if (newDeckMenuItem === "leaveMeeting") {
                _this.leaveMeeting();
            } else if (newDeckMenuItem === "endmeeting") {
                _this.endMeeting();
            } else {
                _this.setState({
                    deckBody: newDeckMenuItem
                });
            }
        };

        _this.state = {
            deckBodyDisplayStyle: 'block',
            deckBody: 'chat',
            deckMode: 'maximised',
            unreadMessageCount: null
        };
        return _this;
    }

    _createClass(Deck, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.type === "stacked") {
                this.setState({
                    deckBodyDisplayStyle: 'none',
                    deckMode: 'minimised'
                });
            }
        }
    }, {
        key: 'getGuestname',
        value: function getGuestname(participants) {
            var guestname = null;
            if (participants.length > 0) {
                participants.forEach(function (participant) {
                    Object.keys(participant).forEach(function (key) {
                        if (participant[key] === 'guest') {
                            guestname = participant['name'];
                        }
                    });
                });
            }
            return guestname;
        }
    }, {
        key: 'render',
        value: function render() {
            var chatDisplay = this.state.deckBodyDisplayStyle === "block" && this.state.deckBody === "chat" ? "block" : "none";

            var chatElement = _react2.default.createElement(
                'div',
                { id: 'deck_body', style: { flex: '1', marginLeft: '15px', height: "415px", width: '270px', display: chatDisplay } },
                _react2.default.createElement(
                    _chat2.default,
                    {
                        changeUnreadMessageCount: this.changeUnreadMessageCount,
                        deckMode: this.state.deckMode,
                        meetingId: this.props.deck.meeting_id,
                        chatteeId: this.props.deck.currentUserId,
                        chatteeName: this.props.deck.currentUserName,
                        user_type: 'agent',
                        position: '',
                        mask_user_typing_text: false,
                        user_join_leave_event: true,
                        height: '351px',
                        width: '300px',
                        displayMode: 'DISPLAYMODE_NORMAL' //DISPLAYMODE_NORMAL, DISPLAYMODE_ICON, DISPLAYMODE_HIDE       
                        , showHeader: false //true or false
                        , showBody: true //true or false
                        , showFooter: true //true or false
                        , participants: this.props.deck.participantsData.participant_list,
                        skinName: 'blue' },
                    'meeting ',
                    this.props.deck.meeting_id,
                    ' joined'
                )
            );

            var header = null;
            var body = null;

            if (this.state.deckBody === 'visitorInfo') {
                body = _react2.default.createElement(
                    'div',
                    { id: 'deck_body', style: { flex: '1', backgroundColor: "#b0b5ad", overflowX: "auto", height: "415px", width: '300px', display: this.state.deckBodyDisplayStyle } },
                    _react2.default.createElement(_visitor_info2.default, { meetingId: this.props.deck.meeting_id, user_id: this.props.deck.visitorId })
                );
            } else if (this.state.deckBody === "contacts") {
                body = _react2.default.createElement(
                    'div',
                    { id: 'deck_body', style: { flex: '1', backgroundColor: "#b0b5ad", overflowX: "auto", height: "415px", width: '300px', display: this.state.deckBodyDisplayStyle } },
                    _react2.default.createElement(_contacts2.default, { meetingId: this.props.deck.meeting_id })
                );
            }

            if (this.props.type === "visible") {
                header = _react2.default.createElement(_deck_header.DeckHeaderNormalMode, {
                    key: Math.random() * 10000,
                    onDeckMenuItemChange: this.onDeckMenuItemChange,
                    deckMode: this.state.deckMode,
                    unreadMessageCount: this.state.unreadMessageCount,
                    removeDeck: this.props.removeDeck,
                    meetingId: this.props.deck.meeting_id,
                    guestName: this.getGuestname(this.props.deck.participantsData.participant_list),
                    visitorOnlineStatus: this.props.deck.visitor.visitorNetworkStatus,
                    style: { flex: '1' },
                    onMinimise: this.onMinimise,
                    onMaximise: this.onMaximise,
                    onclose: this.onClose });
            } else if (this.props.type === "stacked") {
                header = _react2.default.createElement(_deck_header.DeckHeaderMinMode, {
                    removeDeck: this.props.removeDeck,
                    unreadMessageCount: this.state.unreadMessageCount,
                    meetingId: this.props.deck.meeting_id,
                    title: "Chat " + this.props.deck.meeting_id,
                    visitorOnlineStatus: this.props.deck.visitor.visitorNetworkStatus,
                    key: Math.random() * 10000,
                    style: { flex: '1' },
                    moveToVisibleDecks: this.moveToVisibleDecks,
                    onclose: this.onClose });
            }

            return _react2.default.createElement(
                'div',
                { style: { float: 'left', display: 'flex', flexFlow: 'column', paddingBottom: "1px" } },
                header,
                body,
                chatElement
            );
        }
    }]);

    return Deck;
}(_react.Component);

exports.default = Deck;


// WEBPACK FOOTER //
// ../chat/lib/components/dock/deck.js